import React, { useEffect } from 'react';
import { usePrevious } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';
import { useHits, useInfiniteHits } from 'react-instantsearch';
const SearchResultsHeadless = props => {
  const {
    className = '',
    children,
    loadAllPages = false,
    loadAllPagesDelay = 10
  } = props;
  const {
    hits: defaultHits
  } = useHits();
  const {
    hits: infiniteHits,
    results,
    isLastPage,
    showMore
  } = useInfiniteHits();
  const previousHits = usePrevious(infiniteHits) || [];

  // If we want to load all data, we need to load the data in chunks as
  // to not overload the server calls too much. The chunk size is simply the
  // pagination size.
  useEffect(() => {
    // To load all data we call the `showMore` function repeatedly.
    // Doing that, an issue got raised where the `showMore` function would be called
    // again, before the previous one finished. That caused the chunk of results
    // that should've been fetched by the previous run to be missing from the results.
    //
    // To prevent that we save a copy of the results before fetching new ones.
    // Then we only start fetching again if we've confirmed that the previous results
    // are less then the current results. That confirms that the fetch has finished properly.
    if (loadAllPages && showMore && !isLastPage && previousHits.length < infiniteHits.length) {
      setTimeout(() => {
        showMore();
      }, loadAllPagesDelay);
    }
  }, [loadAllPages, loadAllPagesDelay, results === null || results === void 0 ? void 0 : results.page, showMore, infiniteHits, previousHits, isLastPage]);
  const classNames = c('Searchkit__SearchResultsHeadless', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, children && children(loadAllPages ? infiniteHits : defaultHits));
};
export default SearchResultsHeadless;